module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/parking.svg?9f3a031ca6cfdf12a9b18d9a2c46bccb";